// Agentic PDDs open in agentic-pdd while the RedirectToAgenticPdd flag is on; with the flag off
// they fall back to the client portal's PDD page.
export const agenticPddUrl = (options, srfId, isAgentic) =>
  isAgentic && options?.redirectToAgenticPdd ? `${options.agenticPddAddress}#/srf/${srfId}` : null;
